import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { Button, Form, ButtonGroup, Modal, Dropdown, DropdownButton, Col, Row } from 'react-bootstrap';

import Close from '../../../assets/img/close.svg';
import openInNewIcon from '../../../assets/img/open-in-new.svg';
import saveIcon from '../../../assets/img/save.svg';

import { createForecasting, openModal } from '../ForecastingActions';

import '../Forecasting.scss';

const defaultState = {
  percentiles: [
    { text: '30%', value: '30', date: moment() },
    { text: '50%', value: '50', date: moment() },
    { text: '70%', value: '70', date: moment() },
    { text: '85%', value: '85', date: moment() },
    { text: '95%', value: '95', date: moment() },
    { text: '98%', value: '98', date: moment() }
  ],
  views: [],
  model: {
    url: '',
    name: '',
    percentile: '30',
    selectedView: 'default',
    totalItems: 0,
    startDate: moment()
  }
};

class ForecastingConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...defaultState,
      isOpened: props.visible
    };
  }

  onButtonClick = () => {
    if (!this.state.isOpened) {
      const model = this.props.model
        ? {
            totalItems: 0,
            ...this.props.model,
            startDate: moment(this.props.model.startDate)
          }
        : {
            ...defaultState.model
          };
      this.props.openModal();
      this.setState({
        ...defaultState,
        isOpened: true,
        model
      });
    }
  };

  onClose = event => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({
      isOpened: false
    });
    !!this.props.onClose && this.props.onClose();
  };

  handleSubmit = event => {
    event.preventDefault();
    const model = this.formatModel(this.state.model);
    this.props.createForecasting(model._id || 'new', this.props.dashboardId, model).then(() => {
      this.onClose();
    });
  };

  formatModel = model => {
    return {
      _id: model._id,
      name: model.name,
      startDate: model.startDate.toISOString(),
      selectedView: model.selectedView,
      percentile: model.percentile,
      totalItems: model.totalItems || 0
    };
  };

  renderViewValue = value => {
    let option = _.find(this.props.views, { _id: value });
    if (option) {
      return option.name;
    }
    option = _.find(this.props.views, { _id: 'default' });
    if (option) {
      return option.name;
    }
  };

  selectView = id => {
    this.setState({
      model: {
        ...this.state.model,
        selectedView: id
      }
    });
  };

  /*handleRadio = e => {
    this.setState({
      model: {
        ...this.state.model,
        percentile: e.value
      }
    });
  };*/

  handleRadio = id => {
    this.setState({
      model: {
        ...this.state.model,
        percentile: id
      }
    });
  };

  handleStartDateChange = value => {
    this.setState({
      model: {
        ...this.state.model,
        startDate: value
      }
    });
  };

  handleRemainingItemsChange = e => {
    const value = e.target.value;
    this.setState({
      model: {
        ...this.state.model,
        totalItems: value
      }
    });
  };

  handleNameChange = e => {
    const value = e.target.value;
    this.setState({
      model: {
        ...this.state.model,
        name: value
      }
    });
  };

  render() {
    const { model, isOpened } = this.state;
    const { views, dateFormat } = this.props;

    var modal = (
      <Modal
        keyboard={false}
        backdrop={'static'}
        show={isOpened}
        onHide={this.onClose}
        className='forecasting-settings-modal'>
        <Modal.Header>
          <Modal.Title>Forecast configuration</Modal.Title>
          <Button variant="close" onClick={this.onClose}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>
        <Modal.Body className='form_content'>
          <Form onSubmit={this.handleSubmit}>
            <Form.Group controlId="name" >
              <Form.Label>Forecasting Name</Form.Label>
              <Form.Control type="text" name="name" value={model.name} onChange={this.handleNameChange} />
            </Form.Group>

            {model._id && (
              <Form.Group controlId="url" className='display_url_input'>
                <Form.Label>Forecasting Dashboard URL</Form.Label>
                <div>
                  <Form.Control type="text" name="url" value={model.url} readOnly />
                  <a href={model.url} target="_blank" className='btn btn-md btn-secondary'>
                    <img src={openInNewIcon} alt="#" />
                    Open
                  </a>
                </div>
              </Form.Group>
            )}

            <Row>
              <Col sm={5}>
                <Form.Group controlId="startdate">
                  <DateRangePicker
                    locale={{ format: dateFormat }}
                    startDate={model.startDate}
                    singleDatePicker
                    onApply={(e, picker) => this.handleStartDateChange(picker.startDate)}
                  >
                    <div>
                      <label>Start Date</label>
                      <div className='date form-control'>
                        {moment(model.startDate).format(dateFormat)}
                      </div>
                    </div>
                  </DateRangePicker>
                </Form.Group>
              </Col>
              <Col sm={7}>
                { views && views.length && (<Form.Group controlId="views">
                  <Form.Label>Dashboard View</Form.Label>
                  <DropdownButton
                    id="views"
                    className="form-control-dropdown"
                    title={this.renderViewValue(model.selectedView)}
                  >
                    {views &&
                      views.map((v, i) => (
                        <Dropdown.Item key={i} onClick={() => this.selectView(v._id)}>
                          {v.name}
                        </Dropdown.Item>
                      ))}
                  </DropdownButton>
                </Form.Group>)}
              </Col>
            </Row>

            <Row className='select_list_check'>
              <Col sm={5}>
                <Form.Group controlId="total-items" className='select_statuses_content'>
                  <Form.Label> Items to Complete </Form.Label>
                  <input
                    name="totalItems"
                    type="number"
                    id="total-items"
                    placeholder="Completed Items"
                    className='form-control'
                    value={model.totalItems}
                    onChange={this.handleRemainingItemsChange}
                  />
                </Form.Group>
              </Col>
              <Col sm={7}>
                <Form.Group controlId="percentile" className='select_percentile_input'>
                  <Form.Label>Delivery Commitment</Form.Label>
                  <ButtonGroup id="percentile">
                    {this.state.percentiles.map((s, i) => (
                      <Button variant='secondary' size='md' 
                              key={i}
                              id={i} 
                              onClick={() => this.handleRadio(s.value)} className={model.percentile == s.value && 'active'}>
                        {s.text}
                      </Button>
                    ))}
                  </ButtonGroup>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit" onClick={this.handleSubmit}>
            <img src={saveIcon} alt='' />
            {this.props.isLoading ? 'Loading...' : model._id ? 'Update' : 'Start tracking'}
          </Button>
          <Button variant='secondary' onClick={this.onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );

    var content;
    if (this.props.children) {
      var btn = React.Children.only(this.props.children);
      content = React.cloneElement(
        btn,
        {
          ...btn.props,
          onClick: this.onButtonClick
        },
        btn.props.children,
        modal
      );
    } else {
      content = (
        <Button onClick={this.onButtonClick} style={this.props.style}>
          {this.props.buttonText}
          {modal}
        </Button>
      );
    }

    return content;
  }
}

ForecastingConfig.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func,
  dashboard: PropTypes.object,
  model: PropTypes.object
};

ForecastingConfig.defaultProps = {
  visible: false
};

const mapDispatchToProps = dispatch => {
  return {
    createForecasting: (id, dashboardId, data) => dispatch(createForecasting(id, dashboardId, data)),
    openModal: () => dispatch(openModal())
  };
};

const mapStateToProps = state => {
  return {
    isLoading: state.wallboards.loading,
    dateFormat: state.filters.dateFormat,
    views: state.wallboards.views,
    forecasting: state.forecasting.forecasting,
    created: state.forecasting.created
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForecastingConfig);
